<template>
  <v-card flat>
    <v-container style="min-height:400px;">
      <div v-if="!isLoading">
        <v-img :src=p.imageurl max-width="400px" max-height="400px" style="margin:0 auto;"></v-img>
        <h1 class="newsTitle">{{p.title}}</h1>
        <p class="newsSiteName">
            {{p.sitename}}
          <span class="newsDate">{{dateStr}}</span>
        </p>
        <p>{{p.description}}</p>
        <a :href="p.url" target="_blank">
          <v-btn outline block color=primary>続きを読む</v-btn>
        </a>
      </div>
      <div v-show="isLoading" style="text-align:center;">
        <div style="height:100px"></div>
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        <div style="height:100px"></div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import { db } from '@/main'

export default {
  data () {
    return {
      newsId: '',
      p: undefined,
      isLoading: true,
      dateStr: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      window.scroll(0, 0)
      this.isLoading = true
      this.newsId = this.$route.params.newsId

      // storeを検索
      this.p = this.$store.getters.getNewsPostById(this.newsId)
      // storeになかったらAPIで検索
      if (this.p === undefined) {
        // let params = {id: this.newsId}
        // let res = await axios.get(newsApiPosts, {params: params})
        let doc = await db.collection('news').doc(this.newsId).get()
        if (doc) {
          this.p = doc.data()
          this.p.id = doc.id
        }
      }

      // 日付のフォーマッティング
      if (this.p.releaseDate) {
        let cols = this.p.releaseDate.split(/[-T]/)
        this.dateStr = Number(cols[1]) + '月' + cols[2] + '日'
      }
      this.$emit('updateHead')
      this.isLoading = false
    }
  },
  head: {
    title () {
      return {
        inner: this.p.title,
        separator: ' ',
        complement: 'カライイネ！'
      }
    },
    meta () {
      return [
        {name: this.p.description, content: '激辛・旨辛なカップ麺、やきそば、ペヤングなどの新商品情報、辛い物に関するネットニュース・トピックスなど激辛・旨辛に関する新着情報をキュレーションしました'}
      ]
    }
  }
}
</script>

<style scoped>
  .newsTitle {
    font-size: 13pt;
    margin-top:10px;
    margin-bottom: 10px;
  }
  .newsSiteName{
    color:#666;
    font-size:11pt;
    margin-bottom: 10px;
  }
  .newsDate {
    font-size: 10pt;
    margin-left: 10px;
  }
  p {
    margin:0;
  }
  a {
    text-decoration: none;
  }
</style>
